import { NavigationItem } from 'src/app/core/components/pages-container/interfaces/navigationList.interface';
import { HOME_ROUTE } from './constants';

export const routes: NavigationItem[] = [
  {
    id: 1,
    name: 'Home',
    routeUrl: '/home',
    isOutSideUrl: true,
    iconClass: 'ph ph-house',
    outsideUrlTarget: 'core',
    permissions: ['DispatcherHomeView'],
    children: [
      {
        id: 11,
        name: 'Dashboard',
        routeUrl: '/home',
        isOutSideUrl: true,
        outsideUrlTarget: 'core',
        iconClass: 'ph ph-gauge',
        permissions: ['DispatcherHomeView'],
        children: [],
      },
    ],
  },
  {
    id: 2,
    name: 'Dispatch',
    iconClass: 'ph ph-path',
    isOutSideUrl: true,
    outsideUrlTarget: 'core',
    routeUrl: '/',
    permissions: [
      'DispatcherRouteAssignmentUsersView',
      'DispatcherLiveMapUsersView',
      'DispatcherDriversAssignmentsView',
      'DispatcherInterestZoneView',
      'DispatcherHistoricalVehiclesReportView',
      'DispatcherRunManagementView',
      'DispatcherRouteManagementView',
    ],

    children: [
      {
        id: 1,
        name: 'Routes',
        iconClass: 'ph ph-traffic-sign',
        isOutSideUrl: true,
        outsideUrlTarget: 'dispatch',
        routeUrl: '/routes',
        permissions: [
          'DispatcherRunManagementView',
          'DispatcherRouteManagementView',
        ],
        children: [
          {
            id: 1,
            name: 'Routes Management',
            iconClass: '',
            isOutSideUrl: true,
            outsideUrlTarget: 'dispatch',
            routeUrl: '/routes/routes-management',
            permissions: ['DispatcherRouteManagementView'],
            children: [],
          },
          {
            id: 2,
            name: 'Runs Management',
            iconClass: '',
            isOutSideUrl: true,
            outsideUrlTarget: 'dispatch',
            routeUrl: '/routes/runs-management',
            permissions: ['DispatcherRunManagementView'],
            children: [],
          },
        ],
      },
      {
        id: 2,
        name: 'Live Map',
        iconClass: 'ph ph-line-segments',
        isOutSideUrl: true,
        outsideUrlTarget: 'dispatch',
        routeUrl: '/live-map',
        permissions: ['DispatcherLiveMapUsersView'],
        children: [],
      },
      {
        id: 3,
        name: 'Live Dispatch',
        iconClass: 'ph ph-line-segments',
        isOutSideUrl: true,
        outsideUrlTarget: 'dispatch',
        routeUrl: '/live-dispatch',
        permissions: ['DispatcherLiveMapUsersView'],
        children: [],
      },
      {
        id: 4,
        name: 'Interest Zones',
        iconClass: 'ph ph-map-pin-area',
        isOutSideUrl: true,
        outsideUrlTarget: 'dispatch',
        routeUrl: '/interest-zones',
        permissions: ['DispatcherInterestZoneView'],
        children: [],
      },
      {
        id: 5,
        name: 'Driver Assignment',
        iconClass: 'ph ph-user-circle-plus',
        isOutSideUrl: true,
        outsideUrlTarget: 'dispatch',
        routeUrl: '/driver-Assignments',
        permissions: ['DispatcherDriversAssignmentsView'],
        children: [],
      },
      {
        id: 6,
        name: 'Route Assignment',
        iconClass: 'ph ph-stack-plus',
        isOutSideUrl: true,
        outsideUrlTarget: 'dispatch',
        routeUrl: '/route-assignments',
        permissions: ['DispatcherRouteAssignmentUsersView'],
        children: [],
      },
      {
        id: 7,
        name: 'Tasks Assignments',
        iconClass: 'ph ph-stack-plus',
        isOutSideUrl: true,
        outsideUrlTarget: 'dispatch',
        routeUrl: '/tasks-assignments',
        permissions: ['DispatcherRouteAssignmentUsersView'],
        children: [],
      },
      {
        id: 8,
        name: 'Reports',
        iconClass: 'ph ph-files',
        isOutSideUrl: true,
        outsideUrlTarget: 'dispatch',
        routeUrl: '/reports',
        permissions: ['DispatcherHistoricalVehiclesReportView'],
        children: [
          {
            id: 1,
            name: 'Historical Vehicles',
            iconClass: '',
            isOutSideUrl: true,
            outsideUrlTarget: 'dispatch',
            routeUrl: '/reports/historical-vehicles',
            permissions: ['DispatcherHistoricalVehiclesReportView'],
            children: [],
          },
        ],
      },
      {
        id: 9,
        name: 'Time Verification',
        iconClass: 'ph ph-calendar-check',
        isOutSideUrl: true,
        outsideUrlTarget: 'dispatch',
        routeUrl: '/time-verification',
        permissions: ['DispatcherTimeVerificationView'],
        children: [],
      },
    ],
  },
  {
    id: 3,
    name: 'Customers',
    iconClass: 'ph ph-building-office',
    isOutSideUrl: true,
    outsideUrlTarget: 'core',
    routeUrl: '/customers',
    permissions: [
      'DispatcherDistrictsView',
      'DispatcherSchoolsView',
      'DispatcherRoutingRequestsView',
      'DispatcherVideoRequestsView',
      'DispatcherIncidentReportView',
      'DispatcherCalenderView',
      'DispatcherDistrictsUsersView',
    ],
    children: [
      {
        id: 1,
        name: 'Customers',
        iconClass: 'ph ph-users-three',
        isOutSideUrl: true,
        outsideUrlTarget: 'core',
        routeUrl: '',
        permissions: [
          'DispatcherDistrictsView',
          'DispatcherDistrictsUsersView',
        ],
        children: [
          {
            id: 1,
            name: 'Main Customers',
            iconClass: '',
            isOutSideUrl: true,
            outsideUrlTarget: 'core',
            routeUrl: '/customers/main-customers',
            permissions: ['DispatcherDistrictsView'],
            children: [],
          },
          {
            id: 2,
            name: 'Sub Customers',
            iconClass: '',
            isOutSideUrl: true,
            outsideUrlTarget: 'core',
            routeUrl: '/customers/sub-customers',
            permissions: ['DispatcherDistrictsView'],
            children: [],
          },
          {
            id: 3,
            name: 'Customers Users',
            iconClass: '',
            isOutSideUrl: true,
            outsideUrlTarget: 'core',
            routeUrl: '/customers/customers-users',
            permissions: ['DispatcherDistrictsUsersView'],
            children: [],
          },
        ],
      },
      {
        id: 2,
        name: 'interactions',
        iconClass: 'ph ph-hand-tap',
        isOutSideUrl: true,
        outsideUrlTarget: 'core',
        routeUrl: '/customers/interactions',
        permissions: ['DispatcherCalenderView', 'DispatcherAnnouncementView'],
        children: [
          {
            id: 1,
            name: 'Calendar And Events',
            iconClass: '',
            isOutSideUrl: true,
            outsideUrlTarget: 'core',
            routeUrl: '/customers/interactions/calender-and-events',
            permissions: ['DispatcherCalenderView'],
            children: [],
          },
          {
            id: 2,
            name: 'Bulletin Board',
            iconClass: '',
            isOutSideUrl: true,
            outsideUrlTarget: 'core',
            routeUrl: '/customers/interactions/bulletin-board',
            permissions: ['DispatcherAnnouncementView'],
            children: [],
          },
        ],
      },
      {
        id: 3,
        name: 'Requests',
        iconClass: 'ph ph-arrow-bend-double-up-right',
        isOutSideUrl: true,
        outsideUrlTarget: 'core',
        routeUrl: '/customers/requests',
        permissions: [
          'DispatcherRoutingRequestsView',
          'DispatcherVideoRequestsView',
        ],
        children: [
          {
            id: 1,
            name: 'Routing Requests',
            iconClass: '',
            isOutSideUrl: true,
            outsideUrlTarget: 'core',
            routeUrl: '/customers/requests/routing-requests',
            permissions: ['DispatcherRoutingRequestsView'],
            children: [],
          },
          {
            id: 2,
            name: 'Video Requests',
            iconClass: '',
            isOutSideUrl: true,
            outsideUrlTarget: 'core',
            routeUrl: '/customers/requests/video-requests',
            permissions: ['DispatcherVideoRequestsView'],
            children: [],
          },
        ],
      },
      {
        id: 4,
        name: 'Reports',
        iconClass: 'ph ph-files',
        isOutSideUrl: true,
        outsideUrlTarget: 'core',
        routeUrl: '/customers/incident-reports',
        permissions: ['DispatcherIncidentReportView'],
        children: [
          {
            id: 1,
            name: 'Incident-report',
            iconClass: '',
            isOutSideUrl: true,
            outsideUrlTarget: 'core',
            routeUrl: '/customers/incident-reports',
            permissions: ['DispatcherIncidentReportView'],
            children: [],
          },
        ],
      },
    ],
  },
  {
    id: 4,
    name: 'Passengers',
    iconClass: 'ph ph-users-four',
    isOutSideUrl: true,
    outsideUrlTarget: 'core',
    routeUrl: '/passengers',
    permissions: [
      'DispatcherGuardiansView',
      'DispatcherStudentsView',
      'DispatcherRideCancelationRequestsView',
    ],
    children: [
      {
        id: 2,
        name: 'Students',
        iconClass: 'ph ph-graduation-cap',
        isOutSideUrl: true,
        outsideUrlTarget: 'core',
        routeUrl: '/passengers/students',
        permissions: ['DispatcherStudentsView'],
        children: [],
      },
      {
        id: 1,
        name: 'Family',
        iconClass: 'ph ph-tree-structure',
        isOutSideUrl: true,
        outsideUrlTarget: 'core',
        routeUrl: '/passengers/families',
        permissions: ['DispatcherGuardiansView'],
        children: [],
      },
      {
        id: 3,
        name: 'Requests',
        iconClass: 'ph ph-arrow-bend-double-up-right',
        isOutSideUrl: true,
        outsideUrlTarget: 'core',
        routeUrl: '',
        permissions: ['DispatcherRideCancelationRequestsView'],
        children: [
          {
            id: 1,
            name: 'Ride Cancellation Requests',
            iconClass: '',
            isOutSideUrl: true,
            outsideUrlTarget: 'core',
            routeUrl: '/passengers/cancellation-requests',
            permissions: ['DispatcherRideCancelationRequestsView'],
            children: [],
          },
        ],
      },
    ],
  },
  {
    id: 5,
    name: 'Drivers & Vehicles',
    iconClass: 'ph ph-bus',
    isOutSideUrl: true,
    outsideUrlTarget: 'core',
    routeUrl: '/drivers',
    permissions: [
      'DispatcherDriversView',
      'DispatcherDriversAlertView',
      'DispatcherVehiclesView',
    ],
    children: [
      {
        id: 1,
        name: 'Drivers',
        iconClass: 'ph ph-seatbelt',
        isOutSideUrl: true,
        outsideUrlTarget: 'core',
        routeUrl: '/drivers',
        permissions: ['DispatcherDriversView'],
        children: [],
      },
      {
        id: 2,
        name: 'Drivers Alerts',
        iconClass: 'ph ph-warning',
        isOutSideUrl: true,
        outsideUrlTarget: 'core',
        routeUrl: '/drivers/alerts',
        permissions: ['DispatcherDriversAlertView'],
        children: [],
      },
      {
        id: 3,
        name: 'Vehicles',
        iconClass: 'ph ph-car-simple',
        isOutSideUrl: true,
        outsideUrlTarget: 'core',
        routeUrl: '/drivers/vehicles',
        permissions: ['DispatcherVehiclesView'],
        children: [],
      },
    ],
  },
  {
    id: 6,
    name: 'Messaging',
    iconClass: 'ph ph-chats-circle',
    isOutSideUrl: true,
    outsideUrlTarget: 'core',
    routeUrl: '/messaging',
    permissions: ['DispatcherMessagingView'],
    children: [],
  },
];

export const dashboardRoutes: NavigationItem[] = [
  {
    id: 1,
    name: 'Dashboard',
    iconClass: 'ph ph-house',
    isOutSideUrl: true,
    outsideUrlTarget: 'core',
    routeUrl: HOME_ROUTE,
    children: [
      {
        id: 1,
        name: 'Dashboard',
        iconClass: '',
        isOutSideUrl: true,
        outsideUrlTarget: 'core',
        routeUrl: HOME_ROUTE,
        children: [],
      },
      {
        id: 2,
        name: 'Usage reports',
        iconClass: '',
        isOutSideUrl: true,
        outsideUrlTarget: 'core',
        routeUrl: '/usage-report',
        children: [],
      },
    ],
  },
  {
    id: 13,
    name: 'Dashboards',
    iconClass: 'ph ph-chart-pie-slice',
    isOutSideUrl: false,
    routeUrl: '/dashboards',
    children: [
      {
        id: 2,
        name: 'Dashboards Track 2',
        iconClass: 'ph ph-cursor',
        isOutSideUrl: false,
        routeUrl: '/dashboards/dashboard-track-2',
        children: [],
      },
    ],
  },
];

export const settingRoutes: NavigationItem = {
  id: 12,
  name: 'Settings',
  iconClass: 'ph ph-gear-six',
  isOutSideUrl: true,
  outsideUrlTarget: 'core',
  routeUrl: '/settings',
  permissions: [
    'DispatcherSystemUsersView',
    'DispatcherRolesPermissionsView',
    'DispatcherCustomersRolesAndPermissionsView',
    'DispatcherToolsView',
    'DispatcherRegionsAndLocationsView',
    'DispatcherContactsView',
    'DispatcherLocationKiosksView',
    'DispatcherLoginAuditReportView',
    'DispatcherResponsabilitiesView',
    'DispatcherJobTitleView',
    'DispatcherLocationsYardsView',
    'DispatcherLocationsYardsView',
  ],
  children: [
    {
      id: 1,
      name: 'Users',
      iconClass: 'ph ph-users',
      isOutSideUrl: true,
      outsideUrlTarget: 'core',
      routeUrl: '/settings/users',
      permissions: [
        'DispatcherSystemUsersView',
        'DispatcherRolesPermissionsView',
        'DispatcherCustomersRolesAndPermissionsView',
      ],
      children: [
        {
          id: 1,
          name: 'System Users',
          iconClass: '',
          isOutSideUrl: true,
          outsideUrlTarget: 'core',
          routeUrl: '/settings/users/system-users',
          permissions: ['DispatcherSystemUsersView'],
          children: [],
        },
        {
          id: 2,
          name: 'Permissions',
          iconClass: '',
          isOutSideUrl: true,
          outsideUrlTarget: 'core',
          routeUrl: '/settings/users/permissions',
          permissions: ['DispatcherRolesPermissionsView'],
          children: [],
        },
        {
          id: 3,
          name: 'Client Permissions',
          iconClass: '',
          isOutSideUrl: true,
          outsideUrlTarget: 'core',
          routeUrl: '/settings/users/clientPermissions',
          permissions: ['DispatcherCustomersRolesAndPermissionsView'],
          children: [],
        },
      ],
    },
    {
      id: 2,
      name: 'Apps',
      iconClass: 'ph ph-circles-four',
      isOutSideUrl: true,
      outsideUrlTarget: 'core',
      routeUrl: '/settings/Apps',
      permissions: ['DispatcherToolsView'],
      children: [],
    },
    {
      id: 3,
      name: 'Locations Setup',
      iconClass: 'ph ph-map-pin-area',
      isOutSideUrl: true,
      outsideUrlTarget: 'core',
      routeUrl: '/settings/locations-setup',
      permissions: [
        'DispatcherRegionsAndLocationsView',
        'DispatcherLocationsView',
        'DispatcherLocationKiosksView',
      ],
      children: [
        {
          id: 1,
          name: 'Regions',
          iconClass: '',
          isOutSideUrl: true,
          outsideUrlTarget: 'core',
          routeUrl: '/settings/locations-setup/regions',
          permissions: ['DispatcherRegionsAndLocationsView'],
          children: [],
        },
        {
          id: 2,
          name: 'Locations',
          iconClass: '',
          isOutSideUrl: true,
          outsideUrlTarget: 'core',
          routeUrl: '/settings/locations-setup/locations',
          permissions: ['DispatcherLocationsView'],
          children: [],
        },
        {
          id: 3,
          name: 'Location kiosks',
          iconClass: '',
          isOutSideUrl: true,
          outsideUrlTarget: 'core',
          routeUrl: '/settings/locations-setup/location-kiosks',
          permissions: ['DispatcherLocationKiosksView'],
          children: [],
        },
      ],
    },
    {
      id: 4,
      name: 'Contacts',
      iconClass: 'ph ph-address-book',
      isOutSideUrl: true,
      outsideUrlTarget: 'core',
      routeUrl: '/settings/contacts',
      permissions: [
        'DispatcherContactsView',
        'DispatcherResponsabilitiesView',
        'DispatcherJobTitleView',
      ],
      children: [
        {
          id: 1,
          name: 'Contacts List',
          iconClass: '',
          isOutSideUrl: true,
          outsideUrlTarget: 'core',
          routeUrl: '/settings/contacts/contacts-list',
          permissions: ['DispatcherContactsView'],
          children: [],
        },
        {
          id: 2,
          name: 'Job Titles',
          iconClass: '',
          isOutSideUrl: true,
          outsideUrlTarget: 'core',
          routeUrl: '/settings/contacts/job-titles',
          permissions: ['DispatcherJobTitleView'],
          children: [],
        },
        {
          id: 3,
          name: 'Responsibilities',
          iconClass: '',
          isOutSideUrl: true,
          outsideUrlTarget: 'core',
          routeUrl: '/settings/contacts/responsibilities',
          permissions: ['DispatcherResponsabilitiesView'],
          children: [],
        },
      ],
    },
    {
      id: 5,
      name: 'Login Audit Report',
      iconClass: 'ph ph-files',
      isOutSideUrl: true,
      outsideUrlTarget: 'core',
      routeUrl: '/settings/LoginAuditReport',
      permissions: ['DispatcherLoginAuditReportView'],
      children: [],
    },
    // {
    //   id: 6,
    //   name: 'Task Codes',
    //   iconClass: 'ph ph-cards',
    //   isOutSideUrl: false,
    //   routeUrl: '/settings/task-codes',
    //   permissions: ['DispatcherTaskCodeView'],
    //   children: [],
    // },
    // {
    //   id: 7,
    //   name: 'Locations And Yards',
    //   iconClass: 'ph ph-map-pin-plus',
    //   isOutSideUrl: false,
    //   routeUrl: '/settings/locations-and-yards',
    //   permissions: ['DispatcherLocationsYardsView'],
    //   children: [],
    // },
  ],
};

export const BIRoutes: NavigationItem[] = [];

export const BIDashboardRoutes: NavigationItem[] = [
  {
    id: 13,
    name: 'Dashboards',
    iconClass: 'ph ph-chart-pie-slice',
    isOutSideUrl: false,
    routeUrl: '/dashboards',
    children: [
      {
        id: 2,
        name: 'Dashboards Track 2',
        iconClass: 'ph ph-cursor',
        isOutSideUrl: false,
        routeUrl: '/dashboards/dashboard-track-2',
        children: [],
      },
    ],
  },
];

export const BISettingRoutes: NavigationItem = {
  id: 122,
  name: 'BI Portal Settings',
  iconClass: 'ph ph-gear-six',
  routeUrl: '/bi-settings',
  isOutSideUrl: false,
  settingPermissions: ['UsersAndPermissions', 'RolesAndPermissions'],
  permissions: [],
  children: [
    {
      id: 1,
      name: 'Users & Permissions',
      iconClass: 'ph ph-lock-key',
      isOutSideUrl: false,
      routeUrl: '/bi-settings/users-and-permissions',
      settingPermissions: ['UsersAndPermissions'],
      permissions: [],
      children: [],
    },
    {
      id: 2,
      name: 'Dashboards Settings',
      iconClass: 'ph ph-sliders',
      isOutSideUrl: false,
      routeUrl: '/bi-settings/dashboards-settings',
      settingPermissions: ['RolesAndPermissions'],
      permissions: [],
      children: [],
    },
  ],
};
